export default "assets/images/9df733bcb29a746cb16b47eedea9fc3a.png";